import React from "react"
import Layout from "../../components/layout"
import DiscussProject from "../../components/DiscussProject"
import useLang from "../../hooks/useLang"

const DiscussProjectPage = () => {
  const lang = useLang()

  return (
    <Layout title="Discuss Your Project" description="Get in touch with us" lang={lang}>
      <DiscussProject />
    </Layout>
  )
}

export default DiscussProjectPage
